import React, { useEffect } from "react";
import { Button, Col, Layout, Modal, notification, Row } from "antd";
import { Outlet, useNavigate } from "react-router-dom";

import api from "../../services/api";
import { useStateValue } from "../../state";
import { HeaderPage, MenuPage } from "../../components";
import { parametrosEmpresaActions, tributacaoActions } from "../../actions";
import { setPermissoes, setStatusPlano, setNavegacao, getEmpresa, setParametrosEmpresa, setValidadeCertificado, getValidadeCertificado, setParametrosLocal ,setEstadoEmitente} from "../../services/auth";
import moment from 'moment';
import { carregarDadosPdv, diferencaDatas, isObjetoDiffVazio } from "../../services/funcoes";
import { useState } from "react";
import { ModalEditarPDV } from "../../components/modals";

export default function Home({ pdvBloqueado }) {

    const [{ }, dispatch] = useStateValue();
    const navigation = useNavigate();
    const [abreModalSerie, setAbreModalSerie] = useState(false);
    const [dadosPdv, setDadosPdv] = useState({});

    function onCloseModalSerie() {
        setAbreModalSerie(false);
    };

    function buscarParametros() {
        api.get('ParametroEmpresa/BuscarParametrosEmpresa').then(
            res => {
                if (res.status === 200) {
                    dispatch({ type: parametrosEmpresaActions.CHANGE, data: { markupProduto: res.data.par_markupproduto, par_diastoleranciacobrancajuro: res.data.par_diastoleranciacobrancajuro, par_percjuromesparcelavencida: res.data.par_percjuromesparcelavencida, par_multaparcelavencida: res.data.par_multaparcelavencida, par_acaoparcelavencida: res.data.par_acaoparcelavencida, par_diastolparcelavencida: res.data.par_diastolparcelavencida } });
                    setParametrosEmpresa(res.data);
                }
            }
        ).catch(
            (erro) => {
                console.error(erro);
            }
        );
        api.get('ParametroLocal/BuscarParametrosLocal').then(
            res => {
                if (res.status === 200) {
                    setParametrosLocal(res.data);
                    if (!res.data.ope_id) {
                        notification.warning({ message: 'Aviso!', description: 'Operação Fiscal não cadastrada nos parâmetros do Local!' });
                    }
                }
            }
        ).catch(
            (erro) => {
                console.error(erro);
            }
        );
    }

    async function empresaUsuario() {
        let dadosEmpresa = (await api.get(`Empresa/Buscar/${getEmpresa()}`)).data
        dispatch({ type: tributacaoActions.CHANGE, data: { empRegimeTributario: dadosEmpresa.emp_regimetributario, empEnquadramentoFiscal: dadosEmpresa.emp_enquadramentofiscal } });
    }


    // Verificar se da para salvar em local para não ficar sempre fazendo request.. ver se precisa colocar um lembrar mais tarde nessa msg
    async function verificaSerieNFe() {
        let pdv = await carregarDadosPdv();
        if (!pdv) {
            notification.warning({ message: 'Aviso!', description: 'Cadastro do PDV não encontrado.' });
            return;
        }
        setDadosPdv(pdv);
        if (!!!pdv.ser_idnfe) {
            setAbreModalSerie(true);
        }
    }

    useEffect(() => {
        empresaUsuario();
        resetarNav();
        buscarParametros();
        buscarPermissoesUsuario();
        buscarStatusPlano();
        buscarDadosCertificado();
        verificaSerieNFe();
        buscarEstadoEmitente();
    }, []);

    function resetarNav() {
        if (!!!localStorage.getItem('@GestorWeb-Navegacao')) {
            setNavegacao({ geral: {} });
        }
    }

    function buscarPermissoesUsuario() {
        api.get(`PermissaoUsuario/Listar`).then(
            (res) => {
                setPermissoes(res.data);
            }
        ).catch(
            error => {
                if (error.response.status === 426) {
                    Modal.warn({
                        title: error.response.data
                    });
                    navigation("semAcesso");
                    //window.location = 'Home#/semAcesso'
                } else {
                    console.log(error);
                }
            }
        )
    }

    async function buscarEstadoEmitente() {
        try {
            const res = await api.get(`Estado/BuscarEstadoEmitente`);
            if (res.status === 200 && res.data) {
                setEstadoEmitente(res.data);
            }
        } catch (erro) {
            console.error("Erro ao buscar Estado local:", erro);
        }
    }

    async function retornaConfiguracaoCertificado() {
        try {
            const res = await api.get('/LocalConfigNfe/RetornaConfiguracaoNfe');
            if (res.status === 200 && res.data.lcn_validadecertificado) {
                console.log("Retorno certificado:", res.data);
                var clickNaoExibir = {
                    dataValidade: res.data.lcn_validadecertificado,
                    naoMostrarNovamente: false,
                    diferencaDias: [15, 10, 5, 1, 0],
                };
                setValidadeCertificado(clickNaoExibir);
            } else {
                console.error("Resposta inesperada da API:", res);
            }
        } catch (erro) {
            console.error("Erro ao buscar configuração do certificado:", erro);
        }
    }
    function naoExibirMensagem() { //quando chamada função joga "naoMostrarNovamente"=true e nao exibe a mensagem até o proximo logout
        let dados = getValidadeCertificado();
        Modal.destroyAll();
        dados.naoMostrarNovamente = true;
        setValidadeCertificado(dados);
    }
    function exibirModalAviso(diasParaVencimento, dataValidade) { // Aviso exibido sempre que o valor de dif estiver dentro de [15, 10, 5, 1,]
        let formattedDate = moment(dataValidade).format("DD/MM/YYYY");
        const diaOuDias = diasParaVencimento === 1 ? "dia" : "dias"; //trata plural ou singular
        Modal.confirm({
            title: 'Aviso!',
            content: (
                <div style={{}}>
                    <p>O certificado expira em: {diasParaVencimento} {diaOuDias}!</p>
                    <p>Vencimento em: {formattedDate}</p>
                </div>

            ),
            footer: (
                <div style={{ textAlign: "center" }}>
                    <Button style={{ marginRight: "5px" }} onClick={() => exibirModalAvisoDiferencaDias(diasParaVencimento)}>
                        Nao exibir novamente
                    </Button>
                    <Button style={{ backgroundColor: "#014080", color: "white" }} onClick={() => Modal.destroyAll()}>
                        Ok
                    </Button>
                </div>
            )
        });
    }
    function exibirModalAvisoDiferencaDias(diferencaDias) { //aviso2, mostra em quantos dias a mensagem sera exibida de novo
        const diaOuDias = diferencaDias === 1 ? "dia" : "dias";
        Modal.info({
            title: 'Atenção!',
            content: (
                <div>
                    <p>
                        A mensagem será exibida novamente em {diferencaDias} {diaOuDias} ou no próximo acesso ao sistema.
                    </p>
                </div>
            ),
            footer: (
                <div style={{ textAlign: "center" }}>
                    <Button style={{ backgroundColor: "#014080", color: "white" }} onClick={() => naoExibirMensagem()}>
                        Ok
                    </Button>

                </div>
            )
        });
    }
    function exibirModalVencimentoHoje() { //aviso exibido no dia de vencimento (dif===0)
        Modal.confirm({
            title: 'Certificado Digital vence hoje!',
            content: (
                <div>
                    <p>Após o vencimento, a emissão de notas será bloqueada. Contate seu contador!</p>
                </div>
            ),
            footer: (
                <div style={{ textAlign: "center" }}>
                    <Button style={{ marginRight: "5px" }} onClick={() => naoExibirMensagem()}>
                        Nao exibir novamente
                    </Button>
                    <Button style={{ backgroundColor: "#014080", color: "white" }} onClick={() => Modal.destroyAll()}>
                        Ok
                    </Button>
                </div>
            )
        });
    }
    async function buscarDadosCertificado() {

        let dados = getValidadeCertificado();
        if (!isObjetoDiffVazio(dados)) {
            return
        }

        if (dados.naoMostrarNovamente === true) {
            return;
        }

        if (!dados.dataValidade || !dados.diferencaDias) {
            await retornaConfiguracaoCertificado();
            dados = getValidadeCertificado();

            if (!isObjetoDiffVazio(dados) || !dados.dataValidade) {
                console.error("Erro ao obter dados do certificado.");
                return;
            }
        }
        const dif = diferencaDatas(dados.dataValidade);

        if (dif === 0) {
            exibirModalVencimentoHoje();
        } else if ([15, 10, 5, 1, 0].includes(dif)) {
            exibirModalAviso(dif, dados.dataValidade);
        }
    }

    function buscarStatusPlano() {
        api.get(`LocalPlano/VerificarStatusPlano`).then(
            res => {

            }
        ).catch(
            error => {
                if (error.response.status === 402) {
                    setStatusPlano('VENCIDO');
                    navigation("renovarPlano");
                    //window.location = '/renovarPlano#'
                }
            }
        )
    }

    return (
        <div className="App">
            <Layout className={`vh100 ${pdvBloqueado ? "pdv-blur" : ""}`}>
                <HeaderPage />
                <Layout className="vh100 m-t-55">
                    <MenuPage />
                    <Layout className="site-layout">
                        <Layout.Content>
                            <Outlet />
                        </Layout.Content>
                    </Layout>
                </Layout>
            </Layout>
            <ModalEditarPDV exibirModalPDV={abreModalSerie} fecharModalPDV={() => { onCloseModalSerie() }} dadosPdv={dadosPdv} setDadosPdv={setDadosPdv} />
            {pdvBloqueado && (
                <div className="pdv-lock-overlay">
                    <div className="pdv-lock-box">
                        <h2>
                            O PDV foi aberto em outra janela.
                            <br />
                            Essa sessão foi pausada.
                        </h2>
                        <Row justify="center" gutter={[8, 0]}>
                            <Col>
                                <Button
                                    size="large"
                                    className="botao-fechar"
                                    onClick={() => {
                                        window.location.href = "https://www.gestorweb.com.br/";
                                    }}
                                >
                                    Fechar
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    type="primary"
                                    size="large"
                                    style={{ fontWeight: 'bold' }}
                                    onClick={() => window.location.reload()}
                                >
                                    Reabrir aqui
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </div>
    );
}